import { render } from "./bed_classes.vue?vue&type=template&id=7e492e6e&scoped=true"
import script from "./bed_classes.vue?vue&type=script&lang=js"
export * from "./bed_classes.vue?vue&type=script&lang=js"

import "./bed_classes.vue?vue&type=style&index=0&id=7e492e6e&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e492e6e"]])

export default __exports__